import { useLang, ui, tx } from "../i18n";
import { Icon } from "./Icon";
import { ContactForm } from "./ContactForm";
import { SubscribeForm } from "./SubscribeForm";

const RESOURCES = [
  { id: "nmead", name: "NMEAD — Manejo de Emergencias", url: "https://manejodeemergencias.pr.gov" },
  { id: "prgov", name: "Gobierno de Puerto Rico", url: "https://www.pr.gov" },
  { id: "nws-sju", name: "NWS San Juan", url: "https://www.weather.gov/sju" },
  { id: "aaa", name: "AAA — Acueductos", url: "https://www.acueductospr.com" },
  { id: "luma", name: "LUMA Energy", url: "https://lumaenergy.com" },
  { id: "salud", name: "Departamento de Salud", url: "https://www.salud.pr.gov" },
  { id: "familia", name: "Departamento de la Familia", url: "https://www.familia.pr.gov" },
  { id: "assmca", name: "ASSMCA — Línea PAS", url: "https://www.assmca.pr.gov" },
  { id: "fema", name: "FEMA", url: "https://www.fema.gov/es" },
  { id: "rspr", name: "Red Sísmica de Puerto Rico", url: "https://redsismica.uprm.edu" },
];

export function SobreTab() {
  const { lang } = useLang();
  return (
    <div data-testid="sobre-tab" className="px-4 sm:px-8 lg:px-12 py-10 sm:py-14 max-w-5xl">
      <p className="mb-3 font-mono-pr text-xs font-bold uppercase tracking-[0.2em] text-amber-700">preparatepr.org</p>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900">{tx(ui.about.title, lang)}</h2>

      <section className="mt-10 rounded-lg border border-slate-300 bg-white p-6 sm:p-8">
        <div className="flex items-start gap-5">
          <img src="/logo.png" alt="preparatepr.org" className="deco hidden w-20 shrink-0 sm:block" loading="lazy" />
          <div className="min-w-0">
            <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900 mb-4">{tx(ui.about.missionTitle, lang)}</h3>
            <p data-testid="mission-statement" className="text-base sm:text-lg leading-relaxed text-slate-700">{tx(ui.about.mission, lang)}</p>
            <p className="mt-3 text-base leading-relaxed text-slate-600">{tx(ui.about.missionP2, lang)}</p>
          </div>
        </div>
      </section>

      <section className="mt-8">
        <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900 mb-4">{tx(ui.about.goalsTitle, lang)}</h3>
        <div className="grid gap-3 sm:grid-cols-2">
          {ui.about.goals.map((g, i) => (
            <div key={i} data-testid={`goal-${i}`} className="rounded-lg border-l-4 border-green-700 border border-slate-300 bg-white p-5">
              <p className="font-display font-bold text-slate-900">{tx(g.t, lang)}</p>
              <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{tx(g.d, lang)}</p>
            </div>
          ))}
        </div>
      </section>

      <section data-testid="subscribe-section" className="mt-8 rounded-lg border-l-4 border-green-700 border border-slate-300 bg-white p-6 sm:p-8 max-w-3xl">
        <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900 mb-4">{tx(ui.directory.subscribeTitle, lang)}</h3>
        <SubscribeForm />
      </section>

      <section data-testid="contact-section" className="mt-8 rounded-lg border border-slate-300 bg-white p-6 sm:p-8 max-w-3xl">
        <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900 mb-4">{tx(ui.about.contactTitle, lang)}</h3>
        <ContactForm />
      </section>

      <section className="mt-8">
        <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900 mb-4">{tx(ui.about.resourcesTitle, lang)}</h3>
        <div className="grid gap-3 sm:grid-cols-2">
          {RESOURCES.map((r) => (
            <a
              key={r.id}
              data-testid={`resource-${r.id}`}
              href={r.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between gap-3 rounded-lg border border-slate-300 bg-white px-5 py-4 font-semibold text-slate-800 transition-colors duration-200 hover:border-amber-600 hover:text-amber-800"
            >
              {r.name}
              <Icon name="ExternalLink" className="w-4 h-4 shrink-0 text-slate-400 transition-colors duration-200 group-hover:text-amber-700" />
            </a>
          ))}
        </div>
      </section>

      <section className="mt-8 rounded-lg border-l-4 border-amber-600 border border-slate-300 bg-amber-50 p-6 sm:p-8">
        <h3 className="flex items-center gap-2.5 font-display text-lg font-bold text-slate-900 mb-3">
          <Icon name="TriangleAlert" className="w-5 h-5 text-amber-700" />
          {tx(ui.about.disclaimerTitle, lang)}
        </h3>
        <p data-testid="disclaimer-text" className="text-sm sm:text-base leading-relaxed text-amber-900">{tx(ui.about.disclaimer, lang)}</p>
      </section>
    </div>
  );
}
